import { Tag } from "@stenajs-webui/elements";
import type { FC } from "react";

import {
  getPaymentIndicatorStatusText,
  getPaymentStatusDisplayProps,
} from "../../common/utils/paymentUtil";
import type { PaymentStatus } from "../../gql/graphql";

export const PaymentStatusLabel: FC<{ status: PaymentStatus }> = ({
  status,
}) => {
  const label = getPaymentIndicatorStatusText(status);
  const { icon, tagVariant } = getPaymentStatusDisplayProps(status);

  if (!label) {
    return null;
  }

  return (
    <Tag
      icon={icon}
      variant={tagVariant}
      label={label}
      className={"t_payment_status_label"}
    />
  );
};
